/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  try {
    let isProcessing = false;
    const sarHTML = `<span class="devHiddenCurrency" style="display:none;">SAR</span> <span class="devRiyalSymbol"><svg id="Layer_1" width="14" height="auto" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39"> <defs></defs> <path class="cls-1" d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"></path> <path class="cls-1" d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"></path> </svg> </span>`

    function replaceSR() {
      if (isProcessing) return;
      isProcessing = true;

      var titles = document.querySelectorAll(
        '[class*="free_shipping_card_title_"], [class*="free_shipping_bar_title_"]'
      );
      titles.forEach(function (el) {
        if (
          el.innerHTML.indexOf(' SR') !== -1 &&
          el.innerHTML.indexOf('devRiyalSymbol') === -1
        ) {
          el.innerHTML = el.innerHTML.replace(/ SR/g, ' ' + sarHTML);
        }
      });

      setTimeout(function () {
        isProcessing = false;
      }, 100);
    }

    replaceSR();
    const observer = new MutationObserver(replaceSR);
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (error) {
    console.error(
      'Error when changing Free Shipping app titles to the correct currency.',
      error
    );
  }
})();

 

